import useStore from '@/store';

const useCurrentTime = () => {
  const { getCurrentTime } = useStore();
  return {
    getCurrentTime,
  };
};
export default useCurrentTime;
